export const theme = {
    color: {
      alto: "#DDDDDD",
      teal: "#008080",
      silver: "#BBBBBB",
      japaneseLaurel: "#008000",
      red: "#E60000"
    },
    breakpoints: {
      mobile: 767
    },
    bodyWidth: 1000,
  };